var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7b1ffa590607bd211dc1fb149b96a3818470c0e8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@incept-3d"]={id:"7b1ffa590607bd211dc1fb149b96a3818470c0e8"};
      